import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import Dialog from '../shared/Dialog';
import { storeWithExpiration } from '../../utils/common';

const CREATE = 1;
const EDIT = 2;
const UPLOAD = 3;

const BLANK_VALUES = new Map({
  id: 0,
  dataFilenamePattern: '',
  layoutFilename: '',
  recordLevelTypeId: 0,
});

export default class FilesetPage extends React.Component {
  static propTypes = {
    datasetId: PropTypes.number.isRequired,
    datasetName: PropTypes.string.isRequired,
    filesets: PropTypes.object.isRequired,
    pageProgression: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    recordLevelTypes: PropTypes.object.isRequired,
    openDialogFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    deleteFilesetFunction: PropTypes.func.isRequired,
    fetchFieldsByIdFunction: PropTypes.func.isRequired,
    fieldSummary: PropTypes.object.isRequired,
  };

  state = {
    accordionsOpen: [],
  };

  toggleAccordion = newAccordionId => () => {
    const { accordionsOpen } = this.state;
    const { fetchFieldsByIdFunction, fieldSummary, datasetId } = this.props;

    const location = accordionsOpen.indexOf(newAccordionId);
    if (location >= 0) {
      this.state.accordionsOpen.splice(location);
      this.setState({
        accordionsOpen: this.state.accordionsOpen,
      });
    } else {
      if (fieldSummary.get(newAccordionId) === undefined) {
        const token = storeWithExpiration.get('token');
        fetchFieldsByIdFunction(token, datasetId, newAccordionId);
      }
      this.state.accordionsOpen.push(newAccordionId);
      this.setState({
        accordionsOpen: this.state.accordionsOpen,
      });
    }
  };

  toggleDialog = id => {
    const { dialog, openDialogFunction, closeDialogFunction } = this.props;
    if (dialog.show) {
      closeDialogFunction(id);
    } else {
      openDialogFunction(id);
    }
  };

  cancelDialog = id => {
    const { closeDialogFunction } = this.props;
    closeDialogFunction(id);
  };

  dialogSuccess = (datasetId, fileset) => () => {
    const { deleteFilesetFunction } = this.props;
    this.toggleDialog(fileset.id);
    deleteFilesetFunction(datasetId, fileset);
  };

  handleEdit = id => () => {
    this.toggleDialog(id);
  };

  renderFileset = fileset => {
    const { accordionsOpen } = this.state;

    const isOpen = accordionsOpen.reduce((l, r) => l || r === fileset.id, false);

    return (
      <div key={fileset.id} className="col-md-4">
        <div className="card card-block">
          <div className="panel panel-default" key={fileset.id}>
            <div className="panel-heading" role="tab" id={fileset.id}>
              <div className="panel-title">
                <div
                  data-toggle="collapse"
                  data-parent="#accordion"
                  role="button"
                  tabIndex={0}
                  onClick={this.toggleAccordion(fileset.id)}
                  aria-expanded={isOpen}
                  aria-controls={fileset.id}
                  className="collapsed"
                >
                  <p>
                    <strong>Fileset: {fileset.id} </strong>
                  </p>
                </div>
              </div>
            </div>
            <div
              id="collapseOne"
              className={isOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse'}
              role="tabpanel"
              aria-labelledby={fileset.id}
              aria-expanded={isOpen}
            >
              {isOpen ? this.renderFilesetInfo(fileset) : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderFilesetInfo = fileset => {
    const { pageProgression, datasetId, dialog, fieldSummary, recordLevelTypes } = this.props;
    const filesetFields = fieldSummary.get(fileset.id);
    const typeId = fileset.recordLevelTypeId;
    const recordLevelDescription =
      recordLevelTypes.size > 0
        ? recordLevelTypes.find(type => type.id === typeId).description
        : null;

    return (
      <div className="modal-wrap">
        <div key={fileset.id}>
          <div className="row">
            <div className="col-md-6">
              <p>
                Data Filename Pattern: {fileset.dataFilenamePattern} <br />
                Record Level Type: {recordLevelDescription} <br />
              </p>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    pageProgression(UPLOAD, fileset);
                  }}
                >
                  Upload Layout
                </button>&nbsp;
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    pageProgression(EDIT, fileset);
                  }}
                >
                  Edit Fileset
                </button>&nbsp;
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.handleEdit(fileset.id.toString())}
                >
                  Delete Fileset
                </button>
              </div>
            </div>
          </div>
          <div className="row" style={{ paddingTop: 20 }}>
            <div className="col-md-6">
              <p>
                Fields:{' '}
                <span className="pull-right">
                  <i className="fa fa-search" />
                </span>
              </p>
              <div id="Fields" className="pre-scrollable" style={{ maxHeight: 300 }}>
                <table className="table" key={fileset.id}>
                  <tbody>
                    {filesetFields === undefined || filesetFields.length === 0 ? (
                      <tr>
                        <td>
                          <p>There are no fields associated with this fileset</p>
                        </td>
                      </tr>
                    ) : (
                      filesetFields.map(this.renderFields)
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {dialog.id === fileset.id.toString() && dialog.show
          ? this.renderDialog(datasetId, fileset)
          : null}
      </div>
    );
  };

  renderFields = field => (
    <tr key={field.id} style={{ maxHeight: 5 }}>
      <td>
        <p className="table-text">
          <strong>{field.name}</strong>&nbsp;&nbsp;
          <span className="text-muted">
            <small>{field.dataType} Fields </small>
          </span>
        </p>
      </td>
    </tr>
  );

  renderDialog = (datasetId, fileset) => {
    const { dialog } = this.props;
    const dialogContent = (
      <div>
        <p>Are you sure you want to delete this fileset?</p>
      </div>
    );

    return (
      <Dialog
        cancelFunction={this.cancelDialog}
        cancelText="Cancel"
        content={dialogContent}
        id={fileset.id.toString()}
        show={dialog.show}
        successFunction={this.dialogSuccess(datasetId, fileset)}
        successText="Delete Fileset"
        title="Delete"
      />
    );
  };

  render() {
    const { filesets, datasetName, pageProgression } = this.props;

    return (
      <div className="contianer">
        <div className="row">
          <div className="col-sm-12 col-md-8">
            <h2>Filesets for {datasetName}</h2>
          </div>
          <div className="col-sm-12 col-md-4">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                pageProgression(CREATE, BLANK_VALUES);
              }}
            >
              Create New Fileset
            </button>
          </div>
        </div>
        {filesets === undefined || filesets.size === 0 ? (
          <p>There are no Filesets currently associated with this account.</p>
        ) : (
          <div id="accordion" role="tablist" aria-multiselectable="true">
            {filesets.valueSeq().map(this.renderFileset)}
          </div>
        )}
      </div>
    );
  }
}
